import type { IFrameMessage } from "@/enums";

/**
 * This function send a message to the parent window. (when the old manager
 * iframed the planner)
 */
export default (message: IFrameMessage, content?: object) => {
  if (!window.parent) {
    return;
  }

  window.parent.postMessage(
    {
      message,
      ...content,
    },
    "*",
  );
};
